import { prsCodes } from '../../libs/utils'
import * as Types from '../types/authTypes'
import axios from 'axios'
import { config } from '../../config'
import { PublicClientApplication } from '@azure/msal-browser'
// const emailapiURL = "https://afficiency-live.whitetac.com/CENTER369";
import localforage from 'localforage'
const currentUrl = window.location.href
export const apiURL = currentUrl.includes('local') ? 'http://178.156.133.97:30872/center369' : '/center369'

export const redirectToURL = (url) => {
  setTimeout(() => {
    window.location.replace(url)
  }, 1)
}

export const login = (data) => async (dispatch) => {
  dispatch({ type: Types.LOGIN_REQUEST })
  data['prsCode'] = prsCodes.login
  try {
    console.log({currentUrl, apiURL, includes: currentUrl.includes('local')})
    const res = await axios.post(`${apiURL}`, data)
    const loginRes = res?.data?.responsePayload || res?.data
    if (loginRes.statusCode === 200) {
      console.log('login in actions: ', loginRes)
      if (!loginRes.productId?.toString().includes('81') || loginRes.productId === null) {
        dispatch({
          type: Types.LOGIN_FAILURE,
          payload: {
            msgText: 'Agent access is forbidden',
            msgTitle: 'Access Denied',
          },
        })
      } else {
        dispatch({
          type: Types.LOGIN_SUCCESS,
          payload: {
            email: loginRes.login,
            firstName: loginRes.FirstName,
            lastName: loginRes.LastName,
            affiliateCode: loginRes.affiliateCode,
            distributorId: loginRes.distributorId,
            otpFlag: loginRes.otp_flag,
          },
        })
      }
    } else {
      dispatch({
        type: Types.LOGIN_FAILURE,
        payload: {
          msgText: loginRes.msgText,
          msgTitle: loginRes.msgTitle,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.LOGIN_FAILURE,
      payload: {
        msgText: 'Incorrect username and/or password',
        msgTitle: 'Something went wrong',
      },
    })
  }
}

export const logout = () => {
  return {
    type: Types.LOGOUT,
  }
}

export const updatePassword = (data) => async (dispatch) => {
  dispatch({ type: Types.UPDATE_PASSWORD_REQUEST })
  data['prsCode'] = '6701C701'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response.statusCode === 200) {
      dispatch({
        type: Types.UPDATE_PASSWORD_SUCCESS,
        payload: {
          prsCode: res.prsCode,
          username: res.username,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.UPDATE_PASSWORD_FAILURE,
      payload: 'Failed to update password',
    })
  }
}

export const getDistributorInfo = (data) => async (dispatch) => {}

export const verifyEmailStepOne = (data) => async (dispatch) => {
  dispatch({ type: Types.VERIFY_EMAIL_STEP_ONE_REQUEST })
  // call dupeCheck first
  const dupeCheckRes = await axios.post(`${apiURL}`, {
    login: data.email,
    prsCode: '3702C702',
    productId: 81401,
  })
  const dupeCheckResponse = dupeCheckRes?.data?.responsePayload || dupeCheckRes?.data
  if (
    dupeCheckResponse.msgText.startsWith('Username already exists') ||
    (dupeCheckResponse.errors && Object.keys(dupeCheckResponse.errors).length)
  ) {
    dispatch({
      type: Types.VERIFY_EMAIL_STEP_ONE_FAILURE,
      payload: {
        msgText: dupeCheckResponse.errors ? dupeCheckResponse.errors.login : dupeCheckResponse.msgText,
        existingUser: true,
        verificationAttempted: false,
        verificationCodeGenerated: false,
      },
    })
    return
  }
  // generate verification code
  const getVerificationCodeRes = await axios.post(`${apiURL}`, {
    ...data,
    prsCode: '3702F702',
  })
  const getVerificationCodeResponse =  getVerificationCodeRes?.data?.responsePayload || getVerificationCodeRes?.data
  if (
    getVerificationCodeResponse.statusCode === 200 &&
    getVerificationCodeResponse.msgText === 'Verification code generated.'
  ) {
    dispatch({
      type: Types.VERIFY_EMAIL_STEP_ONE_SUCCESS,
      payload: {
        ...getVerificationCodeResponse,
        msgText: getVerificationCodeResponse?.msgText,
        existingUser: false,
        verificationAttempted: true,
        verificationCodeGenerated: true,
      },
    })
  } else {
    dispatch({
      type: Types.VERIFY_EMAIL_STEP_ONE_FAILURE,
      payload: {
        ...getVerificationCodeResponse,
        msgText: getVerificationCodeResponse?.msgText,
        existingUser: false,
        verificationAttempted: true,
        verificationCodeGenerated: false,
      },
    })
  }
}

export const verifyEmailStepTwo = (data) => async (dispatch) => {
  dispatch({ type: Types.VERIFY_EMAIL_STEP_TWO_REQUEST })
  const matchVerificationCodeRes = await axios.post(`${apiURL}`, {
    ...data,
    prsCode: '3702F702',
  })
  const matchVerificationCodeResponse = matchVerificationCodeRes?.data?.responsePayload || matchVerificationCodeRes?.data
  if (matchVerificationCodeResponse.msgText === 'Successful Verification Check') {
    dispatch({
      type: Types.VERIFY_EMAIL_STEP_TWO_SUCCESS,
      payload: {
        ...matchVerificationCodeResponse,
        msgText: matchVerificationCodeResponse.msgText,
        emailVerified: true,
        verificationAttempted: true,
      },
    })
  } else {
    dispatch({
      type: Types.VERIFY_EMAIL_STEP_TWO_FAILURE,
      payload: {
        ...matchVerificationCodeResponse,
        msgText: matchVerificationCodeResponse.msgText,
        emailVerified: false,
        verificationAttempted: true,
      },
    })
  }
}

export const getAffiliateInfo = (data) => async (dispatch) => {
  dispatch({
    type: Types.GET_AFFILIATE_INFO,
  })
  const res = await axios.post(`${apiURL}`, {
    ...data,
    prsCode: '3702702A',
  })
  const response = res?.data?.responsePayload || res?.data
  return response
}

export const createAccount = (data) => async (dispatch) => {
  dispatch({
    type: Types.CREATE_ACCOUNT_REQUEST,
  })
  let accountCreated = false
  const createAccountRes = await axios.post(`${apiURL}`, {
    ...data,
    prsCode: '3702E702',
  })
  const createAccountResponse = createAccountRes?.data?.responsePayload || createAccountRes?.data
  if (createAccountResponse.statusCode === 201) {
    dispatch({
      type: Types.CREATE_ACCOUNT_FAILURE,
      payload: {
        ...createAccountResponse,
        msgText: `${createAccountResponse.msgText.substring(
          0,
          createAccountResponse.msgText.length - 1
        )}, please contact support.`,
      },
    })
  } else if (createAccountResponse.statusCode === 200) {
    dispatch({
      type: Types.CREATE_ACCOUNT_SUCCESS,
      payload: {
        ...createAccountResponse,
        msgTitle: 'createAccount success',
        msgText: createAccountResponse.message || '',
      },
    })
    accountCreated = true
  }
  return {
    accountCreated,
  }
}

export const sendForgotPasswordEmail = (data) => async (dispatch) => {
  dispatch({ type: Types.FORGOT_PASSWORD_REQUEST })
  data['prsCode'] = '9701701A'
  data['portal_type'] = 'AP'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({ type: Types.FORGOT_PASSWORD_SUCCESS })
    } else {
      dispatch({
        type: Types.FORGOT_PASSWORD_FAILURE,
        payload: 'Failed to send Forgot Password email',
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.FORGOT_PASSWORD_FAILURE,
      payload: 'Failed to send Forgot Password email',
    })
  }
}

export const getScorecard = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_SCORECARD_REQUEST })
  data['prsCode'] = '3702H702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response.statusCode === 200) {
      dispatch({
        type: Types.GET_SCORECARD_SUCCESS,
        payload: {
          applicationsSubmitted: res.data.responsePayload.applicationsSubmitted,
          approvalRate: res.data.responsePayload.approvalRate,
          displayFlag: res.data.responsePayload.displayFlag,
          excessiveApplicationActivity: res.data.responsePayload.excessiveApplicationActivity,
          fourMonthLapseRate: res.data.responsePayload.fourMonthLapseRate,
          freeLookCancel: res.data.responsePayload.freeLookCancel,
          iaiRate: res.data.responsePayload.iaiRate,
          msgCode: res.data.responsePayload.msgCode,
          msgText: res.data.responsePayload.msgText,
          policiesIssued: res.data.responsePayload.policiesIssued,
          productId: res.data.responsePayload.productId,
          qualityScore: res.data.responsePayload.qualityScore,
          statusCode: res.data.responsePayload.statusCode,
          underwritingInaccuracy: res.data.responsePayload.underwritingInaccuracy,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_SCORECARD_FAILURE,
      payload: 'Failed to get scorecard',
    })
  }
}

export const getScorecardChart = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_SCORECARDCHART_REQUEST })
  data['prsCode'] = '3702I702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({
        type: Types.GET_SCORECARDCHART_SUCCESS,
        payload: {
          chartTotals: res.data.responsePayload.chartTotals,
          msgCode: res.data.responsePayload.msgCode,
          msgText: res.data.responsePayload.msgText,
          statusCode: res.data.responsePayload.statusCode,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_SCORECARDCHART_FAILURE,
      payload: 'Failed to get scorecard chart totals',
    })
  }
}

export const getAggregatedData = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AGGREGATED_DATA_REQUEST })
  data['prsCode'] = '3702J702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({
        type: Types.GET_AGGREGATED_DATA_SUCCESS,
        payload: {
          agentRank: res.data.responsePayload.agentRank,
          monthlyData: res.data.responsePayload.monthlyData,
          msgCode: res.data.responsePayload.msgCode,
          msgText: res.data.responsePayload.msgText,
          productAccess: res.data.responsePayload.productAccess,
          productEligible: res.data.responsePayload.productEligible,
          productId: res.data.responsePayload.productId,
          productLibrary: res.data.responsePayload.productLibrary,
          qualityScore: res.data.responsePayload.qualityScore,
          quarterlyData: res.data.responsePayload.quarterlyData,
          statusCode: res.data.responsePayload.statusCode,
          underwritingInaccuracy: res.data.responsePayload.underwritingInaccuracy,
          weeklyData: res.data.responsePayload.weeklyData,
          yearlyData: res.data.responsePayload.yearlyData,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AGGREGATED_DATA_FAILURE,
      payload: 'Failed to get aggregated data',
    })
  }
}

export const getOpenCases = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_OPEN_CASES_REQUEST })
  data['prsCode'] = '3702L702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({
        type: Types.GET_OPEN_CASES_SUCCESS,
        payload: {
          openCases: res.data.responsePayload.openCases,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_OPEN_CASES_FAILURE,
      payload: 'Failed to get open cases',
    })
  }
}

export const getNotifications = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_NOTIFICATIONS_REQUEST })
  data['prsCode'] = '3702N702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_NOTIFICATIONS_SUCCESS,
        payload: {
          notificationMessage: res.data.responsePayload,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_NOTIFICATIONS_FAILURE,
      payload: 'Failed to get notifications',
    })
  }
}

export const getPresignedUrl = (formData) => async (dispatch) => {
  // formData["prsCode"] = "";
  // try {
  //   const res = await axios.post(`${apiURL}`, formData);
  //   return res;
  // } catch (e) {
  //   console.error(e);
  //   return {
  //     data: null,
  //   };
  // }
}

export const getAgentProduct = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AGENT_PRODUCT_REQUEST })
  data['prsCode'] = '3702T702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_AGENT_PRODUCT_SUCCESS,
        payload: response,
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AGENT_PRODUCT_FAILURE,
      payload: 'Failed to get agent product data.',
    })
  }
}

export const getUserPersona = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_USER_PERSONA_REQUEST })
  data['prsCode'] = '3702R702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_USER_PERSONA_SUCCESS,
        payload: {
          relationalType: res.data.responsePayload.relationalType,
          userSourceId: res.data.responsePayload.userSourceId,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_USER_PERSONA_FAILURE,
      payload: 'Failed to get user persona.',
    })
  }
}

export const getAggregatedDataDistributor = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AGGREGATED_DATA_DIST_REQUEST })
  data['prsCode'] = '3702U702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_AGGREGATED_DATA_DIST_SUCCESS,
        payload: {
          totalAgencies: res.data.responsePayload.totalAgencies,
          totalAgents: res.data.responsePayload.totalAgents,
          monthlyData: res.data.responsePayload.monthlyData,
          msgCode: res.data.responsePayload.msgCode,
          msgText: res.data.responsePayload.msgText,
          productId: res.data.responsePayload.productId,
          productLibrary: res.data.responsePayload.productLibrary,
          productAccess: res.data.responsePayload.productAccess,
          productEligible: res.data.responsePayload.productEligible,
          qualityScore: res.data.responsePayload.qualityScore,
          quarterlyData: res.data.responsePayload.quarterlyData,
          statusCode: res.data.responsePayload.statusCode,
          weeklyData: res.data.responsePayload.weeklyData,
          yearlyData: res.data.responsePayload.yearlyData,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AGGREGATED_DATA_DIST_FAILURE,
      payload: 'Failed to get aggregated data -- distributor level.',
    })
  }
}

export const getScorecardDistributor = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_SCORECARD_DIST_REQUEST })
  data['prsCode'] = '3702Y702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_SCORECARD_DIST_SUCCESS,
        payload: {
          applicationsSubmitted: res.data.responsePayload.applicationsSubmitted,
          approvalRate: res.data.responsePayload.approvalRate,
          displayFlag: res.data.responsePayload.displayFlag,
          excessiveApplicationActivity: res.data.responsePayload.excessiveApplicationActivity,
          fourMonthLapseRate: res.data.responsePayload.fourMonthLapseRate,
          freeLookCancel: res.data.responsePayload.freeLookCancel,
          iaiRate: res.data.responsePayload.iaiRate,
          msgCode: res.data.responsePayload.msgCode,
          msgText: res.data.responsePayload.msgText,
          policiesIssued: res.data.responsePayload.policiesIssued,
          productId: res.data.responsePayload.productId,
          qualityScore: res.data.responsePayload.qualityScore,
          statusCode: res.data.responsePayload.statusCode,
          underwritingInaccuracy: res.data.responsePayload.underwritingInaccuracy,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_SCORECARD_DIST_FAILURE,
      payload: 'Failed to get scorecard-- distributor level.',
    })
  }
}

export const getAgentList = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AGENT_LIST_REQUEST })
  data['prsCode'] = '3702X702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_AGENT_LIST_SUCCESS,
        payload: {
          agentList: res.data.responsePayload,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AGENT_LIST_FAILURE,
      payload: 'Failed to get agent list.',
    })
  }
}

export const getOpenCasesDistributor = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_OPEN_CASES_DIST_REQUEST })
  data['prsCode'] = '3702W702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({
        type: Types.GET_OPEN_CASES_DIST_SUCCESS,
        payload: {
          openCases: res.data.responsePayload.openCases,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_OPEN_CASES_DIST_FAILURE,
      payload: 'Failed to get open cases--distributor',
    })
  }
}

export const getAffiliateLoginInfo = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AFFILIATE_LOGIN_INFO_REQUEST })
  data['prsCode'] = '3702Z702'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_AFFILIATE_LOGIN_INFO_SUCCESS,
        payload: {
          redirect: res.data.responsePayload.redirect,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AFFILIATE_LOGIN_INFO_FAILURE,
      payload: 'Failed to get affiliate login info',
    })
  }
}

export const generateOTP = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_OTP_REQUEST })
  data['prsCode'] = '3702702C'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.statusCode === 200) {
      dispatch({
        type: Types.GET_OTP_SUCCESS,
        payload: {
          otpStatus: res.data.responsePayload.statusCode,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_OTP_FAILURE,
      payload: 'Failed to generate otp',
    })
  }
}

export const validateOTP = (data) => async (dispatch) => {
  dispatch({ type: Types.VALIDATE_OTP_REQUEST })
  data['prsCode'] = '3702702B'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response && response?.statusCode === 200) {
      dispatch({
        type: Types.VALIDATE_OTP_SUCCESS,
        payload: {
          otpValidateStatus: res.data.responsePayload.statusCode,
        },
      })
    } else {
      dispatch({
        type: Types.VALIDATE_OTP_FAILURE,
        payload: {
          otpValidateStatus: `${res.data.responsePayload.msgText}`,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.VALIDATE_OTP_FAILURE,
      payload: {
        otpValidateStatus: 'Failed to validate otp',
      },
    })
  }
}

export const getScorecardChartPersona = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_SCORECARDCHART_PERSONA_REQUEST })
  data['prsCode'] = '3702702E'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response) {
      dispatch({
        type: Types.GET_SCORECARDCHART_PERSONA_SUCCESS,
        payload: {
          chartTotals: res.data.responsePayload,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_SCORECARDCHART_PERSONA_FAILURE,
      payload: 'Failed to get scorecard chart totals',
    })
  }
}

export const getAgencyProductListPersona = (data) => async (dispatch) => {
  dispatch({ type: Types.GET_AGENCYPRODUCTLIST_PERSONA_REQUEST })
  data['prsCode'] = '3702702F'
  try {
    const res = await axios.post(`${apiURL}`, data)
    const response = res?.data?.responsePayload || res?.data
    if (response?.distributors) {
      dispatch({
        type: Types.GET_AGENCYPRODUCTLIST_DISTRIBUTOR_PERSONA_SUCCESS,
        payload: {
          distributorList: res.data.responsePayload.distributors,
          agencyList: res.data.responsePayload.agencies,
          productList: res.data.responsePayload.products,
        },
      })
    } else if (response?.agencies) {
      dispatch({
        type: Types.GET_AGENCYPRODUCTLIST_AGENCY_PERSONA_SUCCESS,
        payload: {
          agencyList: res.data.responsePayload.agencies,
          productList: res.data.responsePayload.products,
        },
      })
    } else if (response?.products) {
      dispatch({
        type: Types.GET_AGENCYPRODUCTLIST_PRODUCT_PERSONA_SUCCESS,
        payload: {
          productList: res.data.responsePayload.products,
        },
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.GET_AGENCYPRODUCTLIST_PERSONA_FAILURE,
      payload: 'Failed to agency and product list data',
    })
  }
}

const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: config.appId,
    redirectUri: config.redirectUri,
    authority: config.authority,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
})

export const ssoLogin = () => async (dispatch) => {
  dispatch({ type: Types.SSO_LOGIN_REQUEST })
  await publicClientApplication.initialize()
  try {
    let name = ''
    await publicClientApplication
      .loginPopup({
        scopes: config.scopes,
        prompt: 'select_account',
      })
      .then(function (loginResponse) {
        name = loginResponse.account['name']
      })
    const splitName = name.split('  ', 2)
    dispatch({
      type: Types.SSO_LOGIN_SUCCESS,
      payload: {
        firstName: splitName[0],
        lastName: splitName[1],
      },
    })
  } catch (err) {
    dispatch({
      type: Types.SSO_LOGIN_FAILURE,
      payload: `${err}`,
    })
  }
}

export const createHubspotTicket = (data) => async (dispatch) => {
  dispatch({ type: Types.HUBSPOT_TICKET_REQUEST })
  data['prsCode'] = '3702702G'
  try {
    const res = await axios.post(`${apiURL}`, data)
    if (res.data) {
      dispatch({
        type: Types.HUBSPOT_TICKET_SUCCESS,
      })
    }
  } catch (e) {
    console.error(e)
    dispatch({
      type: Types.HUBSPOT_TICKET_FAILURE,
      payload: 'Failed to create hubspot ticket',
    })
  }
}
